export default (...classes) =>
  classes
    .filter(c => !!c)
    .join(' ')
    .replace(/,/gim, '');
